export const PERSON_ID_STORAGE_KEY = 'personId';
export const CLIENT_STORAGE_KEY = 'client';
export const CHAT_WIDGET_CLIENT_STORAGE_KEY = 'chatWidget.client';
export const USER_ID_STORAGE_KEY = 'recontact.userId';
export const SUBSCRIBED_ID_STORAGE_KEY = 'yougov-subscriber-id';
